export const setCursorAtEndOfElement = (el: HTMLInputElement | HTMLTextAreaElement) => {
  if (!el.value || el.type === 'number') {
    return;
  }
  // eslint-disable-next-line no-multi-assign
  el.selectionStart = el.selectionEnd = el.value.length;
};
